import { useBookingsStore } from "../../context/useBookingsStore";

export default function BookingsTable({
  bookings,
  isAdmin,
  currentUser,
  onCheckout,
  onReturn,
}) {
  const {
    approveBooking,
    rejectBooking,
    cancelBooking,
  } = useBookingsStore();

  console.log(bookings);

  return (
    <table className="min-w-full border text-sm">
      <thead className="bg-gray-100">
        <tr>
          <th>Vehicle</th>
          <th>Driver</th>
          <th>Status</th>
          <th>From</th>
          <th>To</th>
          <th>Reason</th>
          <th>Actions</th>
        </tr>
      </thead>

      <tbody>
        {bookings.map((b) => (
          <tr key={b.id} className="border-t">
            <td>
              {b.vehicle?.registrationNumber ||
                b.vehicle?.make ||
                `#${b.vehicleId}`}
            </td>

            <td>
              {b.driver
                ? `${b.driver.firstname} ${b.driver.lastname}`
                : b.userId}
            </td>

            <td>
              <StatusBadge status={b.status} />
            </td>

            <td>{formatDate(b.plannedStartTime)}</td>
            <td>{formatDate(b.plannedEndTime)}</td>

            <td className="max-w-xs truncate" title={b.reason}>
              {b.reason}
            </td>

            <td className="space-x-1">
              {/* Admin approval */}
              {isAdmin && b.status === "requested" && (
                <>
                  <button onClick={() => approveBooking(b.id)}>
                    Approve
                  </button>
                  <button
                    className="danger"
                    onClick={() => rejectBooking(b.id, "Rejected")}
                  >
                    Reject
                  </button>
                </>
              )}

              {/* Checkout */}
              {isAdmin && b.status === "approved" && (
                <button onClick={() => onCheckout(b)}>
                  Check out
                </button>
              )}

              {/* Return */}
              {isAdmin && b.status === "checked_out" && (
                <button onClick={() => onReturn(b)}>
                  Return
                </button>
              )}

              {/* Driver cancel */}
              {!isAdmin &&
                b.status === "requested" &&
                b.userId === currentUser.id && (
                  <button
                    className="danger"
                    onClick={() => cancelBooking(b.id)}
                  >
                    Cancel
                  </button>
                )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

/* =========================
   Helpers
   ========================= */

function StatusBadge({ status }) {
  const map = {
    requested: "bg-yellow-100 text-yellow-800",
    approved: "bg-blue-100 text-blue-800",
    checked_out: "bg-green-100 text-green-800",
    returned: "bg-gray-100 text-gray-800",
    rejected: "bg-red-100 text-red-800",
    cancelled: "bg-gray-200 text-gray-600",
  };

  return (
    <span
      className={`px-2 py-0.5 rounded text-xs ${map[status]}`}
    >
      {status}
    </span>
  );
}

function formatDate(d) {
  if (!d) return "-";
  return new Date(d).toLocaleString();
}
